<ng-container *appLoad="let insight of insight$; trackingName: 'opportunity-insight'">
    <app-insight-card [heading]="(insight.value | plural: 'Opportunity' : 'Opportunities')" [change]="insight.change" text="Currently in pipeline">
  </app-insight-card>
</ng-container>